<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'DOCS_MODULE.ACCESS_HISTORY.ACCESS_HISTORY_LIST' | translate"
    [viewLoading$]="dataSource?.loading$"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div *ngIf="document.id">
        <button
          mat-raised-button
          [matTooltip]="'GLOBAL.CLOSE' | translate"
          class="btn btn-icon btn-light"
          (click)="closeDialog($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
            class="svg-icon svg-icon-lg"
          ></span>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.ACCESS_HISTORY.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory">{{ accessHistory.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.ACCESS_HISTORY.ID' | translate }}</mat-label>
              <input
                matInput
                #searchIdInput
                [placeholder]="'DOCS_MODULE.ACCESS_HISTORY.ID' | translate"
              />
              <button
                *ngIf="searchIdInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchIdInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="document_name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.ACCESS_HISTORY.DOCUMENT' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory">{{ accessHistory.document.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDocument">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              *ngIf="!document.id"
              #searchDocumentAutocomplete
              [label]="'DOCS_MODULE.ACCESS_HISTORY.DOCUMENT' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getDocumentAutocomplete"
              [optionFormatter]="formatDocumentOption"
              [valueFormatter]="formatDocumentOption"
              [control]="searchDocumentAutocomplete"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="document_category_name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.ACCESS_HISTORY.CATEGORY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory">{{
            accessHistory.document.category.name
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCategory">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchCategoryAutocomplete
              [label]="'DOCS_MODULE.ACCESS_HISTORY.CATEGORY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getCategoryAutocomplete"
              [optionFormatter]="formatCategoryOption"
              [valueFormatter]="formatCategoryOption"
              [control]="searchCategoryAutocomplete"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="entities">
          <mat-header-cell *matHeaderCellDef>{{
            'DOCS_MODULE.ACCESS_HISTORY.ENTITIES' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory">
            <div class="badged-list">
              <span *ngIf="accessHistory.document.entities?.length">{{
                formatEntityValue(accessHistory.document.entities[0])
              }}</span>
              <span
                *ngIf="accessHistory.document.entities?.length > 1"
                [matTooltip]="getEntitiesString(accessHistory.document.entities, 1)"
                matTooltipPosition="above"
                class="num-badge bg-light-primary text-primary"
              >
                {{ accessHistory.document.entities.length - 1 }}+
              </span>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEntity">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchEntityAutocomplete
              [label]="'DOCS_MODULE.ACCESS_HISTORY.ENTITY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getEntityAutocomplete"
              [optionFormatter]="formatEntityOption"
              [valueFormatter]="formatEntityValue"
              [control]="searchEntityAutocomplete"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="interactionType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.ACCESS_HISTORY.ACCESS_TYPE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory">{{
            stringUtils.formatEnumString(accessHistory.interaction_type)
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchAccessType">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.ACCESS_HISTORY.ACCESS_TYPE' | translate }}</mat-label>
              <mat-select
                #searchAccessTypeSelect
                [placeholder]="'DOCS_MODULE.ACCESS_HISTORY.ACCESS_TYPE' | translate"
              >
                <mat-option value="">All</mat-option>
                <mat-option *ngFor="let type of AccessTypes" [value]="type">{{
                  stringUtils.formatEnumString(type)
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="downloadReason">
          <mat-header-cell *matHeaderCellDef>{{
            'DOCS_MODULE.ACCESS_HISTORY.DOWNLOAD_REASON' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory" class="text-lines-2">{{
            accessHistory.download_reason
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDownloadReason">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="accessTime">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.ACCESS_HISTORY.ACCESS_TIME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory">{{
            accessHistory.access_time | date : 'MMM dd, yyyy hh:mm a'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchAccessTime">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.ACCESS_HISTORY.ACCESS_TIME' | translate }}</mat-label>
              <input
                matInput
                #searchAccessTimeInput
                [matDatepicker]="searchAccessTimePicker"
                [placeholder]="'DOCS_MODULE.ACCESS_HISTORY.ACCESS_TIME' | translate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="searchAccessTimePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #searchAccessTimePicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="userType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.ACCESS_HISTORY.USER_TYPE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory">{{
            stringUtils.formatEnumString(accessHistory.user_type)
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchUserType">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.ACCESS_HISTORY.USER_TYPE' | translate }}</mat-label>
              <mat-select
                #searchUserTypeSelect
                [placeholder]="'DOCS_MODULE.ACCESS_HISTORY.USER_TYPE' | translate"
              >
                <mat-option value="">All</mat-option>
                <mat-option *ngFor="let type of UserTypes" [value]="type">{{
                  stringUtils.formatEnumString(type)
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="accessedBy">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.ACCESS_HISTORY.ACCESSED_BY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory">{{ accessHistory.accessed_by }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchAccessedBy">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.ACCESS_HISTORY.ACCESSED_BY' | translate }}</mat-label>
              <input
                matInput
                #searchAccessedByInput
                [placeholder]="'DOCS_MODULE.ACCESS_HISTORY.ACCESSED_BY' | translate"
              />
              <button
                *ngIf="searchAccessedByInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchAccessedByInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let accessHistory"></mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCols" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarCols"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
